module.exports = __webpack_public_path__ + "static/img/czekolada.56ec0b52.webp";